import React, { ReactNode } from 'react';

import Button from '../../library/button/button';
import Image from '../../library/image/image';
import Typography from '../../library/typography/typography';

import './easy-pay-option.scss';

interface EasyPayOptionProps {
  className?: string;
  imageAlt: string;
  imageUrl: string;
  linkText: string;
  message: ReactNode;
  onClick: () => void;
  showImageAfterMessage?: boolean;
  showLinkAsCTA?: boolean;
  title?: string;
}

function EasyPayOption(props: EasyPayOptionProps) {
  const {
    className = '',
    imageAlt,
    imageUrl,
    linkText,
    message,
    onClick,
    showImageAfterMessage,
    showLinkAsCTA,
    title
  } = props;

  return (
    <aside className={`easy-pay-option ${className}`} styleName="container">
      {imageUrl && !showImageAfterMessage && (
        <Image
          alt={imageAlt}
          className="easy-pay-option__image"
          loading="lazy"
          src={imageUrl}
          styleName="image"
        />
      )}
      <div
        className="easy-pay-option__description-container"
        styleName={`description-container ${
          showLinkAsCTA ? 'description-container-cta' : ''
        }`}
      >
        <div className="easy-pay-option__description" styleName="description">
          {title && (
            <Typography
              className="easy-pay-option__title"
              styleName="title"
              tag="p"
              variant="H6"
            >
              {title}
            </Typography>
          )}
          <Typography
            className="easy-pay-option__message"
            styleName="message"
            tag="p"
            weight="bold"
          >
            {message}
          </Typography>
        </div>
        {linkText && !showLinkAsCTA && (
          <Button
            className="easy-pay-option__link"
            onClick={onClick}
            size="regular"
            styleName="link"
          >
            {linkText}
          </Button>
        )}
        {imageUrl && showImageAfterMessage && (
          <div data-testid="image-after">
            <Image
              alt={imageAlt}
              className="easy-pay-option__image"
              loading="lazy"
              src={imageUrl}
              styleName="image"
            />
          </div>
        )}
      </div>
      {linkText && showLinkAsCTA && (
        <Button
          isSecondary={showLinkAsCTA}
          onClick={onClick}
          size="regular"
          styleName="cta"
        >
          {linkText}
        </Button>
      )}
    </aside>
  );
}

export default EasyPayOption;
